/**
 * Counts the number of words given a string
 * @param {string} string must be provided
 * @returns {number} word count
 */
export const wordCount = (string: string) => {
  const trimmed = string.trim();
  return trimmed ? trimmed.split(/\s+/).length : 0;
};
